<template>
  <Screen>
    <AppBar
      title="Manage splash screens"
      :description="`Add or update BIBO app splash screens`"
      :showBackButton="false"
    >
      <inertia-link
        :href="$route('admin.splashscreens.create')"
        class="btn btn-sm btn-primary"
      >
        <i class="fa fa-plus"></i>
        <span class="d-none d-app-inline">Add new</span>
      </inertia-link>
    </AppBar>
    <Breadcrumbs title="Splash screens" />
    <div class="card">
      <div class="card-body">
        <SearchBar
          @onSubmit="searchSubmit"
          @onClear="searchCleared"
          v-model="searchInput"
        />
        <div class="table-responsive" v-if="data.data.length > 0">
          <table class="table mb-0">
            <thead class="thead-light">
              <tr>
                <th>#</th>
                <th>Thumbnail</th>
                <th>Title</th>
                <th>Sort order</th>
                <th>Status</th>
                <th>Created</th>
                <th>Updated</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in data.data" :key="item.id">
                <td>
                  {{
                    i + 1 + (data.meta.current_page - 1) * data.meta.per_page
                  }}
                </td>
                <td style="width: 0">
                  <img
                    v-lazy="item.thumbnail"
                    :alt="item.title"
                    class="preview-img-sm"
                    width="100"
                    height="100"
                    style="
                      background: linear-gradient(154deg, #c16ad5, #3b28b1);
                    "
                  />
                </td>
                <th style="max-width: 220px">
                  <div>{{ item.title }}</div>
                  <span
                    class="sub-title wrap-text-3"
                    v-text="item.description"
                  ></span>
                </th>
                <td>{{ item.sort_order }}</td>
                <th>
                  <StatusSwitch
                    :dataid="item.id"
                    :status="item.isactive"
                    action="splashScreensStatus"
                  />
                </th>
                <td>{{ item.created_at_human || "-" }}</td>
                <td>{{ item.updated_at_human || "-" }}</td>
                <td>
                  <inertia-link
                    class="btn btn-sm btn-light"
                    :href="
                      $route('admin.splashscreens.edit', {
                        id: item.id,
                      })
                    "
                  >
                    Update
                  </inertia-link>
                  <button
                    @click.prevent="deleteThis(item.id)"
                    class="btn btn-sm btn-danger"
                  >
                    Delete
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <NoData title="No splash screens added yet" v-else>
          <inertia-link
            :href="$route('admin.splashscreens.create')"
            class="btn btn-primary"
          >
            <i class="fa fa-plus"></i> Add new
          </inertia-link>
        </NoData>
        <Pagination :rawData="data.meta" :onClick="pageChange" />
      </div>
    </div>
  </Screen>
</template>
<script>
export default {
  components: {},
  props: {
    data: {
      type: [Array, Object],
      default: () => [],
    },
    search: {
      type: String,
      default: "",
    },
  },
  watch: {
    search: {
      immediate: true,
      handler(value) {
        this.searchInput = value;
      },
    },
  },
  data() {
    return {
      searchInput: "",
    };
  },
  mounted() {},
  methods: {
    async deleteThis(id) {
      this.$root.$emit("confirmModal", {
        title: "Do you want to delete this Splash Screen?",
        message: "You won't be able to revert this!",
        confirmText: "Yes, delete it!",
        onConfirm: () => {
          this.$root.$emit("hold-transition", null);
          this.$inertia.delete(
            this.$route("admin.splashscreens.delete", {
              id: id,
            })
          );
        },
      });
    },
    searchSubmit(search) {
      this.$root.$emit("hold-transition", null);
      this.$inertia.visit(
        this.$route(this.$route().current(), {
          search: search,
          page: 1,
        })
      );
    },
    searchCleared() {
      this.$root.$emit("hold-transition", null);
      this.$inertia.visit(
        this.$route(this.$route().current(), {
          search: "",
          page: 1,
        })
      );
    },
    pageChange(page) {
      this.$root.$emit("hold-transition", null);
      this.$inertia.visit(
        this.$route(this.$route().current(), {
          page: page,
          search: this.searchInput,
        })
      );
    },
  },
  computed: {},
};
</script>
